import {DOCUMENTS} from './documentsActionsTypes';

export const setDocumentTab = (id) => {
  return {
    type: DOCUMENTS.SET_DOCUMENT_TAB,
    payload: id
  }
}

export function createDocument(id, data) {
  return {
    type: DOCUMENTS.CREATE_DOCUMENT,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs`,
        method: 'post',
        data
      }
    }
  };
}

export function getEstimates(id, type) {
  return {
    type: DOCUMENTS.GET_ESTIMATES,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs?filter[type]=${type}`,
        method: 'get'
      }
    }
  };
}

export function getDocument(id, docId) {
  return {
    type: DOCUMENTS.GET_SINGLE_DOCUMENT,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs/${docId}`,
        method: 'get'
      }
    }
  };
}
export function addDocumentsLoading(id,perPage,page,status,query) {
  const filterStatus = status && status !== 'all' ? `&filter[status]= ${status}` : ''
  const filterQuery = query ? `&filter[name]= ${query}` : ''

  return {
    type: DOCUMENTS.ADD_DOCUMENTS,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}/docs?filter[type]=document&perPage=${perPage}&page=${page}${filterStatus}${filterQuery}`,
        method: 'get',
      }
    }
  };
}
export function addDrawingLoading(id,perPage,page,status,query) {
  const filterStatus = status && status !== 'all' ? `&filter[status]= ${status}` : ''
  const filterQuery = query ? `&filter[name]= ${query}` : ''

  return {
    type: DOCUMENTS.ADD_DRAWING,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}/docs?filter[type]=drawing&perPage=${perPage}&page=${page}${filterStatus}${filterQuery}`,
        method: 'get',
      }
    }
  };
}
export function getDrawingsCompany(id,perPage,page =1,status,query,reload = true) {
  const filterStatus = status && status !== 'all' ? `&filter[status]= ${status}` : ''
  const filterQuery = query ? `&filter[name]= ${query}` : ''

  return {
    type: DOCUMENTS.GET_DRAWING,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}/docs?filter[type]=drawing&perPage=${perPage}&page=${page}${filterStatus}${filterQuery}`,
        method: 'get',
        needReload: reload
      }
    }
  };
}

export function getDocumentsCompany(id,perPage,page = 1,status,query,reload = true) {
  const filterStatus = status && status !== 'all' ? `&filter[status]= ${status}` : ''
  const filterQuery = query ? `&filter[name]= ${query}` : ''

  return {
    type: DOCUMENTS.GET_DOCUMENTS,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}/docs?filter[type]=document&perPage=${perPage}&page=${page}${filterStatus}${filterQuery}`,
        method: 'get',
        needReload: reload
      }
    }
  };
}
export function getDrawings(id, type) {
  return {
    type: DOCUMENTS.GET_DRAWING,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs?filter[type]=${type}`,
        method: 'get',
        needReload: true
      }
    }
  };
}

export function getDocuments(id, type) {
  return {
    type: DOCUMENTS.GET_DOCUMENTS,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs?filter[type]=${type}`,
        method: 'get',
        needReload: true
      }
    }
  };
}

export function resetAllDocuments() {
  return {
    type: DOCUMENTS.RESET_ALL_DOCS,
    payload: {}
  };
}

export function resetSingleDoc() {
  return {
    type: DOCUMENTS.RESET_SINGLE_DOC,
    payload: {}
  };
}

export function deleteDoc(id, docId) {
  return {
    type: DOCUMENTS.REMOVE_DOCUMENT,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs`,
        method: 'delete',
        data: {ids: [docId]}
      }
    }
  };
}
export function deleteCompanyDoc(id, docId) {
  return {
    type: DOCUMENTS.REMOVE_DOCUMENT_COMPANY,
    payload: {
      client: 'default',
      request: {
        url: `companies/${id}/docs`,
        method: 'delete',
        data: {ids: [docId]}
      }
    }
  };
}

export function deleteDocs(id, data) {
  return {
    type: DOCUMENTS.REMOVE_DOCUMENTS,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs`,
        method: 'delete',
        data: {ids: data}
      }
    }
  };
}

export function requestApproval(id, docId) {
  return {
    type: DOCUMENTS.REQUEST_APPROVAL,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs/${docId}/request-approval`,
        method: 'post'
      }
    }
  };
}

export function approveDoc(id, docId) {
  return {
    type: DOCUMENTS.APPROVE_DOCUMENT,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs/${docId}/approve`,
        method: 'post'
      }
    }
  };
}
export function rejectDoc(id, docId) {
  return {
    type: DOCUMENTS.REJECT_DOCUMENT,
    payload: {
      client: 'default',
      request: {
        url: `projects/${id}/docs/${docId}/reject`,
        method: 'post'
      }
    }
  };
}

export function downloadDoc(docId) {
  return {
    type: DOCUMENTS.DOWNLOAD_DOCUMENT,
    payload: {
      client: 'default',
      request: {
        url: `projects/docs/download`,
        method: 'post',
        responseType: 'blob',
        data: {ids: docId}
      }
    }
  };
}

export function downloadDocById(projectId, docId) {
  return {
    type: DOCUMENTS.DOWNLOAD_DOCUMENT_BY_ID,
    payload: {
      client: 'default',
      request: {
        url: `projects/${projectId}/docs/${docId}/download`,
        method: 'get',
        responseType: 'blob'
      }
    }
  };
}

export function downloadDocCompanyById(projectId, docId) {
  return {
    type: DOCUMENTS.DOWNLOAD_DOCUMENT_COMPANY_BY_ID,
    payload: {
      client: 'default',
      request: {
        url: `companies/${projectId}/docs/${docId}/download`,
        method: 'get',
        responseType: 'blob'
      }
    }
  };
}

export const setFilterQuery = (filter) => ({
  type: DOCUMENTS.SET_FILTER_QUERY,
  payload: filter,
});
export const setSearchQuery = (query) => ({
  type: DOCUMENTS.SET_SEARCH_QUERY,
  payload: query,
});
export const resetAllCompaniesFilters = () => ({
  type: DOCUMENTS.RESET_ALL_FILTERS,
  payload: {}
});

export function changeDocStatus(projectId, docId,paymentStatus,orderStatus) {
    const data = {};

    if (paymentStatus || paymentStatus === '') {
        data.paymentStatus = paymentStatus;
    }

    if (orderStatus) {
        data.orderStatus = orderStatus;
    }
    return {
        type: DOCUMENTS.UPDATE_DOCUMENT_STATUS,
        payload: {
            client: 'default',
            request: {
                url: `projects/${projectId}/docs/${docId}/statuses`,
                method: 'PATCH',
                data
            }
        }
    };
}
